import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import { getPublicImagePath, ToggleMenu } from '@nutastic/nutastic-react-app';
import classnames from 'classnames';

const componentClass = 'header';

// eslint-disable-next-line react/prop-types
const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuButtonClasses = classnames(`${componentClass}__menu-btn`, {
        isMenuOpen: isMenuOpen
    });

    return <React.Fragment>
        <header className={componentClass}>
            <ReactSVG src={getPublicImagePath('logo--wide.svg')} className={`${componentClass}__logo`} />
            <ToggleMenu isOpen={isMenuOpen} animation="slideFromRight" onOuterClick={() => setIsMenuOpen(false)} className={`${componentClass}__menu`}>
                <div className="nuMenu">
                    <a href="https://linktr.ee/tronlegac" target="_blank" rel="noreferrer">Connect W/ Tron</a>
                    <a href="https://direct.distrokid.com/tronlegac/" target="_blank" rel="noreferrer">Shop W/ Tron</a>
                    <a href="https://www.youtube.com/playlist?list=OLAK5uy_kC9W4m0F64pxwINshvOHTcQoCkQE78Tg8">Rough Draft</a>
                    <a href="https://ybmad254.carrd.co/" target="_blank" rel="noreferrer">Digital Press Kit</a>
                </div>
            </ToggleMenu>
        </header>
        <div className={`${componentClass}__fadedTop`} />
        <div className={menuButtonClasses} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            { isMenuOpen ? <ReactSVG src={ getPublicImagePath('close-icon.svg') } /> : <ReactSVG src={ getPublicImagePath('menu-icon.svg') } /> }
        </div>
    </React.Fragment>;
};

export default Header;
